import RulesSection from "./RulesSection";
export default RulesSection;
